export default "__VITE_ASSET__BU6tAXMc__"